<template>
  <!-- 申请原因及备注 -->
  <div class="apply-reason-memo">
    <div class="ant-descriptions-title">申请原因及备注</div>
    <html-content :content="content" />
    <ul class="attachment-list">
      <li v-for="item in attachments" :key="item.id">
        <a herf="javascript:;" @click="handleDownload(item.id)">
          {{ item.fileName }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import HtmlContent from '../HtmlContent.vue'
import { downloadAttachment } from '../../api'

export default {
  name: 'ApplyReasonRemarkView',
  props: ['content', 'attachments'],
  methods: {
    // 点击文件链接下载
    handleDownload(id) {
      downloadAttachment(id)
    },
  },
  components: {
    HtmlContent,
  },
}
</script>

<style lang="less" scoped>
.apply-reason-memo {
  margin: 20px 0;
}
.attachment-list {
  display: block;
  margin-top: 10px;
  margin-left: -30px;
  li {
    list-style: none;
  }
}
</style>
